"use client";
import { useCallback } from "react";

const styles = new Proxy({"PostTile":"PostTile-a3474","TileTitle":"TileTitle-a3474","TileImg":"TileImg-a3474","TileText":"TileText-a3474"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
import { useRouter } from "next/navigation";
import { FormattedPost } from "@/lib/blog";

const PostTile = ({
  post: { link, title, featuredImage, excerpt },
}: PostTileProps) => {
  const router = useRouter();

  const onClick = useCallback(() => {
    router.push(link);
  }, [router, link]);

  return (
    <div className="col-md-6 col-lg-12 mb-4">
      <div className={`card ${styles.PostTile}`} onClick={onClick} role="none">
        <div className="card-body">
          <h5
            className={styles.TileTitle}
            dangerouslySetInnerHTML={{ __html: title }}
          />

          <div className={styles.TileImg}>
            <img src={featuredImage?.url} alt="Featured" />
          </div>

          <div
            className={styles.TileText}
          >
            <p>
              {excerpt}
            </p>
          </div>
        </div>
      </div>{" "}
    </div>
  );
};

interface PostTileProps {
  post: FormattedPost;
}

export default PostTile;
